import { cva } from 'class-variance-authority';

// Custom Tooltip styles
export const toolTipWrapper = cva(
  'bg-white-50 px-2-5 py-1-5 flex flex-col gap-2 rounded-md shadow-lg backdrop-blur-md'
);

export const toolTipDatasetWrapper = cva('flex flex-col gap-1');

export const toolTipItem = cva('flex items-center gap-2');

export const toolTipItemColor = cva('rounded-2xs h-3 w-3');

//Custom Tick styles
export const tickXWrapper = cva('flex h-full w-full items-start justify-center');

export const tickYWrapper = cva('flex items-center justify-end');

// Chart
export const chartWrapper = cva(
  `[&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border flex justify-center text-xs [&_.recharts-cartesian-grid-vertical_line:first-of-type]:stroke-none [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-hidden [&_.recharts-sector]:outline-hidden [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-surface]:outline-hidden`
);

// Label styles
export const LabelContentTopStyle = cva(
  'font-nista-grotesk leading-xs fill-muted-foreground text-xs font-medium tracking-wide'
);

export const LabelTitleStyle = cva(
  'font-nista-grotesk leading-2xl text-2xl font-medium tracking-wide'
);

export const LabelContentStyle = cva(
  'font-nista-grotesk leading-xs fill-muted-foreground text-xs font-medium tracking-wide'
);
